module.exports = __webpack_public_path__ + "static/media/CHSB.e6405018.svg";